/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function UserEntityActionsRepresentationFromJSON(json) {
    return UserEntityActionsRepresentationFromJSONTyped(json, false);
}
export function UserEntityActionsRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        canUpdate: json['canUpdate'],
        canDelete: json['canDelete'],
    };
}
export function UserEntityActionsRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        canUpdate: value.canUpdate,
        canDelete: value.canDelete,
    };
}
